import { Box, Button, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const BatchForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  heading = '',
  handleCloseModal
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>

      <TextField
        error={Boolean(touched.name && errors.name)}
        fullWidth
        helperText={touched.name && errors.name}
        label="Name"
        margin="normal"
        name="name"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.name}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.start_time && errors.start_time)}
        fullWidth
        helperText={touched.start_time && errors.start_time}
        label="Start Time"
        margin="normal"
        name="start_time"
        onBlur={handleBlur}
        onChange={handleChange}
        type="time"
        value={values.start_time}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.end_time && errors.end_time)}
        fullWidth
        helperText={touched.end_time && errors.end_time}
        label="End Time"
        margin="normal"
        name="end_time"
        onBlur={handleBlur}
        onChange={handleChange}
        type="time"
        value={values.end_time}
        variant="outlined"
      />

      <Box sx={{ py: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {heading}
        </Button>
      </Box>
    </form>
  );
};

export default BatchForm;
